import { GET_MEMBER } from '../../store/member/MemberConstants'
import {
  GET_APPOINTMENT,
  GET_APPOINTMENT_SUCCESS,
  GET_CURRENT_SCHEDULE,
  GET_PATIENT,
} from '../../store/calendar/CalendarConstants'

export const calendarPageBlackList = [
  GET_MEMBER,
  GET_CURRENT_SCHEDULE,
  GET_APPOINTMENT_SUCCESS,
  GET_PATIENT,
  GET_APPOINTMENT,
]
